export enum RegexPatternEnum {
    email = '[^@\\s]+@[^@\\s]+\\.[^@\\s]+'
}
